import { lazy, Suspense } from 'react'

import {
  offersExtrasForMotOnly,
  resolveStepRules,
} from '@ngb-frontend/shared/rules'
import {
  MaintenanceAndRepair,
  type ExtraServiceStepPrerequisiteData,
  type ServiceStepComponentProps,
  type ServiceStepValues,
  type StepComponentContainer,
} from '@ngb-frontend/shared/types'
import { FullScreenLoader } from '@ngb-frontend/shared/ui'
import { camelize } from '@ngb-frontend/shared/utils'

import { hasServiceFormValues } from '../ServiceStep/ServiceStep'

const ServiceStepLazy = lazy(() => import('../ServiceStep/ServiceStep'))

export const ExtraServiceStepContainer: StepComponentContainer<
  ServiceStepValues,
  ExtraServiceStepPrerequisiteData,
  ServiceStepComponentProps
> = (props) => {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <ServiceStepLazy {...props} />
    </Suspense>
  )
}

ExtraServiceStepContainer.areStepPrerequisitesMet = (
  mergedFlowData,
): mergedFlowData is ExtraServiceStepPrerequisiteData =>
  hasServiceFormValues(mergedFlowData, camelize(MaintenanceAndRepair.Service))

ExtraServiceStepContainer.skip = (
  mergedFlowData,
  isLPSystem,
  countryConfig,
) => {
  // Austria/Switzerland still offer the replacement vehicle for MOT-only, so
  // the step is not skipped there — the capability lives in the country profile
  const shouldSkipForALD =
    !mergedFlowData.services?.includes('RegularMaintenance') &&
    !mergedFlowData.services?.includes('Repair') &&
    !offersExtrasForMotOnly({ countryCode: countryConfig?.countryCode })

  return {
    enabled: !!(
      shouldSkipForALD ||
      !resolveStepRules({ isLPSystem, countryConfig }).offersAnyExtraService
    ),
    state: { extraServices: [], services: mergedFlowData.services },
  }
}
